import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class PropertyMessageTagModel extends Model {
  @attr('string') hostFirstName!: string;
  @attr('string') hostSurname!: string;

  @belongsTo('property', {
    inverse: 'propertyMessageTag',
    async: false,
  })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'property-message-tag': PropertyMessageTagModel;
  }
}
